import type {CustomerDiscriminatorEnum} from './CustomerDiscriminatorEnum';
import type {CustomerSourceEnum} from './CustomerSourceEnum';

export type CustomerData = {
  customerDiscriminator: CustomerDiscriminatorEnum;
  customerSource: CustomerSourceEnum | null;
};
